import Http from '@services/Http';
import { EMBRION_API_URL } from '@/data/enviroment';

export default {
  async getPagamentosPorData({ token, data }) {
    return Http(EMBRION_API_URL, token).get(`/Pagamento?data=${data}`);
  },
};
